import _slicedToArray from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import * as React from "react";
/**
 * React hook for force a component to re-render
 */

export function useForceUpdate() {
  var _React$useState = React.useState(0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      count = _React$useState2[0],
      setCount = _React$useState2[1];

  var forceUpdate = React.useCallback(function () {
    return setCount(count + 1);
  }, [count]);
  return forceUpdate;
}